<template>
  <mask-layer v-model="isShow">
    <div class="content">
      <div class="left">
        <div class="img">
          <img :src="data.headimg" v-img>
        </div>
        <p><em>{{data.name}}</em></p>
        <p><span>积分：</span><em>{{data.score||0}}</em></p>
      </div>
      <div class="right">
        <p><span>手机：</span><em>{{data.phone}}</em></p>
        <p><span>邮箱：</span><em>{{data.email}}</em></p>
        <p><span>性别：</span><em>{{data.gender}}</em></p>
        <p><span>城市：</span><em>{{data.city}}</em></p>
        <p><span>状态：</span><em>{{data.status?'正常':'异常'}}</em></p>
        <p><span>签名：</span><em>{{data.signature}}</em></p>
        <p><span>介绍：</span><em>{{data.description}}</em></p>
        <p><span>标签：</span>
          <em v-for="(item,index) in data.tags">{{item}}{{index===data.tags.length-1?"":","}}</em>
        </p>
        <p>
          <span>创建：</span>
          <em>{{data.created_at}}</em>
          <span class="time">({{getDay(data.created_at)}})</span>
        </p>
        <p>
          <span>更新：</span>
          <em>{{data.updated_at}}</em>
          <span class="time">({{getDay(data.updated_at)}})</span>
        </p>
        <p>
          <span>活跃：</span>
          <em>{{data.last_active_at}}</em>
          <span class="time">({{getDay(data.last_active_at)}})</span>
        </p>
      </div>
    </div>
  </mask-layer>
</template>
<script>
import request from '@/utils/request'
import getDay from '@/utils/getDay'
import MaskLayer from '@/components/MaskLayer'
export default {
  name: 'UserMessageCard',
  components: {
    MaskLayer
  },
  data () {
    return {
      isShow: false,
      data: {}
    }
  },
  methods: {
    show (data) {
      let _this = this
      this.isShow = true
      request({
        url: 'users/' + data.uuid,
        method: 'get'
      }).then(res => {
        _this.data = res.data.user
      })
    },
    getDay (date) {
      return getDay(date)
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  width: 830px;
  height: 500px;
  display: flex;
  padding: 0!important;
  font-size: 13px;
  color: #303133;

  p {
    line-height: 37px;
  }

  em {
    padding-right: 10px;
    font-style: normal;
  }

  span {
    color: #999999;
    font-size: 12px;
  }

  i {
    color: #409EFF;
    cursor: pointer;
  }

  .left {
    width: 230px;
    height: 100%;
    border-right: 1px solid #EBEEF5;
    text-align: center;

    .img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      overflow: hidden;
      background-color: #dddddd;
      margin: 0 auto;
      margin-top: 50px;
      margin-bottom: 20px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .right {
    width: 600px;
    height: 100%;

    p {

      &:nth-child(1) {
        margin-top: 45px;
      }

      span {
        padding-right: 20px;
        padding-left: 40px;
      }

      .time {
        padding: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MessageCard/UserMessageCard.vue